<template>
	<div class="modal modal-form-category is-active">
		<div class="modal-background"></div>
		<div class="modal-card">
			<header class="modal-card-head">
				<p class="modal-card-title" v-if="item">Editar caixa dinâmica/ Categoria de links</p>
				<p class="modal-card-title" v-if="!item">Adicionar caixa dinâmica/ Categoria de links</p>
				<button class="delete" aria-label="close" @click="goBack"></button>
			</header>
			<form @submit.prevent="onSubmit()">

				<section class="modal-card-body">

					<div class="field has-addons">
						<div class="control">
							<input class="input" type="text" v-model="name" required placeholder="Nome">
						</div>
					</div>

					<div class="category-color-options">
						<h4>Escolha a cor de fundo</h4>
						<div class="field is-horizontal ">

							<label><input type="radio" v-model="theme" value="00FFFF FFFFFF"><span style="background-color:#00FFFF"></span></label>
							<label><input type="radio" v-model="theme" value="8A2BE2 FFFFFF"><span style="background-color:#8A2BE2"></span></label>
							<label><input type="radio" v-model="theme" value="5F9EA0 FFFFFF"><span style="background-color:#5F9EA0"></span></label>
							<label><input type="radio" v-model="theme" value="FF6347 FFFFFF"><span style="background-color:#FF6347"></span></label>
							<label><input type="radio" v-model="theme" value="4682B4 FFFFFF"><span style="background-color:#4682B4"></span></label>
							<label><input type="radio" v-model="theme" value="303030 FFFFFF"><span style="background-color:#303030"></span></label>
							<label><input type="radio" v-model="theme" value="F8F8F8 303030"><span style="background-color:#F8F8F8"></span></label>
							<label><input type="radio" v-model="theme" value="FFFFFF 303030"><span style="background-color:#FFFFFF"></span></label>

						</div>
					</div>

				</section>
				<footer class="modal-card-foot">
					<div class="columns is-mobile">
						<div class="column">
							<button type="submit" class="button is-success">Salvar</button>
						</div>
						<div class="column is-narrow">
							<button v-if="item" class="button button-delete" @click.prevent="onDelete">
								<span class="icon has-text-danger">
									<svg viewBox="-40 0 427 427.00131" xmlns="http://www.w3.org/2000/svg"><path d="m232.398438 154.703125c-5.523438 0-10 4.476563-10 10v189c0 5.519531 4.476562 10 10 10 5.523437 0 10-4.480469 10-10v-189c0-5.523437-4.476563-10-10-10zm0 0"/><path d="m114.398438 154.703125c-5.523438 0-10 4.476563-10 10v189c0 5.519531 4.476562 10 10 10 5.523437 0 10-4.480469 10-10v-189c0-5.523437-4.476563-10-10-10zm0 0"/><path d="m28.398438 127.121094v246.378906c0 14.5625 5.339843 28.238281 14.667968 38.050781 9.285156 9.839844 22.207032 15.425781 35.730469 15.449219h189.203125c13.527344-.023438 26.449219-5.609375 35.730469-15.449219 9.328125-9.8125 14.667969-23.488281 14.667969-38.050781v-246.378906c18.542968-4.921875 30.558593-22.835938 28.078124-41.863282-2.484374-19.023437-18.691406-33.253906-37.878906-33.257812h-51.199218v-12.5c.058593-10.511719-4.097657-20.605469-11.539063-28.03125-7.441406-7.421875-17.550781-11.5546875-28.0625-11.46875h-88.796875c-10.511719-.0859375-20.621094 4.046875-28.0625 11.46875-7.441406 7.425781-11.597656 17.519531-11.539062 28.03125v12.5h-51.199219c-19.1875.003906-35.394531 14.234375-37.878907 33.257812-2.480468 19.027344 9.535157 36.941407 28.078126 41.863282zm239.601562 279.878906h-189.203125c-17.097656 0-30.398437-14.6875-30.398437-33.5v-245.5h250v245.5c0 18.8125-13.300782 33.5-30.398438 33.5zm-158.601562-367.5c-.066407-5.207031 1.980468-10.21875 5.675781-13.894531 3.691406-3.675781 8.714843-5.695313 13.925781-5.605469h88.796875c5.210937-.089844 10.234375 1.929688 13.925781 5.605469 3.695313 3.671875 5.742188 8.6875 5.675782 13.894531v12.5h-128zm-71.199219 32.5h270.398437c9.941406 0 18 8.058594 18 18s-8.058594 18-18 18h-270.398437c-9.941407 0-18-8.058594-18-18s8.058593-18 18-18zm0 0"/><path d="m173.398438 154.703125c-5.523438 0-10 4.476563-10 10v189c0 5.519531 4.476562 10 10 10 5.523437 0 10-4.480469 10-10v-189c0-5.523437-4.476563-10-10-10zm0 0"/></svg>
								</span>

							</button>

							<button v-if="item" class="button button-share is-pulled-right" @click.prevent="onShare">
								<span class="icon">
									<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 475.082 475.081" xml:space="preserve"><g><path d="M469.658,133.333L360.029,23.697c-3.621-3.617-7.909-5.424-12.854-5.424c-2.275,0-4.661,0.476-7.132,1.425 c-7.426,3.237-11.139,8.852-11.139,16.846v54.821h-45.683c-20.174,0-38.879,1.047-56.101,3.14 c-17.224,2.092-32.404,4.993-45.537,8.708c-13.134,3.708-24.983,8.326-35.547,13.846c-10.562,5.518-19.555,11.372-26.98,17.559 c-7.426,6.186-13.943,13.23-19.558,21.129c-5.618,7.898-10.088,15.653-13.422,23.267c-3.328,7.616-5.992,15.99-7.992,25.125 c-2.002,9.137-3.333,17.701-3.999,25.693c-0.666,7.994-0.999,16.657-0.999,25.979c0,10.663,1.668,22.271,4.998,34.838 c3.331,12.559,6.995,23.407,10.992,32.545c3.996,9.13,8.709,18.603,14.134,28.403c5.424,9.802,9.182,16.317,11.276,19.555 c2.093,3.23,4.095,6.187,5.997,8.85c1.903,2.474,4.377,3.71,7.421,3.71c0.765,0,1.902-0.186,3.427-0.568 c4.377-2.095,6.279-5.325,5.708-9.705c-8.564-63.954-1.52-108.973,21.128-135.047c21.892-24.934,63.575-37.403,125.051-37.403 h45.686v54.816c0,8.001,3.71,13.613,11.136,16.851c2.471,0.951,4.853,1.424,7.132,1.424c5.14,0,9.425-1.807,12.854-5.421 l109.633-109.637c3.613-3.619,5.424-7.898,5.424-12.847C475.082,141.23,473.271,136.944,469.658,133.333z"/><path d="M395.996,292.356c-3.625-1.529-6.951-0.763-9.993,2.283c-4.948,4.568-10.092,8.093-15.42,10.564 c-3.433,1.902-5.141,4.66-5.141,8.277v61.104c0,12.562-4.466,23.308-13.415,32.26c-8.945,8.946-19.704,13.419-32.264,13.419 H82.222c-12.564,0-23.318-4.473-32.264-13.419c-8.947-8.952-13.418-19.697-13.418-32.26V137.039 c0-12.563,4.471-23.313,13.418-32.259c8.945-8.947,19.699-13.418,32.264-13.418h31.977c1.141,0,2.666-0.383,4.568-1.143 c10.66-6.473,23.313-12.185,37.972-17.133c4.949-0.95,7.423-3.994,7.423-9.136c0-2.474-0.903-4.611-2.712-6.423 c-1.809-1.804-3.946-2.708-6.423-2.708H82.226c-22.65,0-42.018,8.042-58.102,24.125C8.042,95.026,0,114.394,0,137.044v237.537 c0,22.651,8.042,42.018,24.125,58.102c16.084,16.084,35.452,24.126,58.102,24.126h237.541c22.647,0,42.017-8.042,58.101-24.126 c16.085-16.084,24.127-35.45,24.127-58.102v-73.946C401.995,296.829,399.996,294.071,395.996,292.356z"/></g></svg>
								</span>
							</button>

						</div>
					</div>
				</footer>
			</form>
		</div>


		<div v-if="modalShare" class="modal modal-share is-active">
			<div class="modal-background"></div>
			<div class="modal-card">
				<header class="modal-card-head">
					<p class="modal-card-title">Compartilhar categoria</p>
					<button class="delete" aria-label="close" @click="closeModalShare"></button>
				</header>
				<section class="modal-card-body">
					<p>Escolha uma opção de compartilhamento</p>
					<p>Link: <span class="share-link" v-if="!isLoading">{{share_link}}</span> <Spinner v-if="isLoading" size="30" /></p>
					<input type="hidden" :value="share_link">
					<div v-if="!isLoading" class="link-share-buttons">

						<a class="link-share-facebook" :href="'https://www.facebook.com/sharer/sharer.php?u='+share_link" target="_blank">
							<span class="icon"><svg viewBox="0 0 24 24"><path d="M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3M18,5H15.5A3.5,3.5 0 0,0 12,8.5V11H10V14H12V21H15V14H18V11H15V9A1,1 0 0,1 16,8H18V5Z" /></svg></span>
							Facebook
						</a>

						<a class="link-share-whatsapp" :href="'https://wa.me/?text=Olá! Clique neste link para adicionar esta categoria ao seu U.R.Links. '+share_link" target="_blank">
							<span class="icon"><svg viewBox="0 0 24 24"><path fill="#000000" d="M16.75,13.96C17,14.09 17.16,14.16 17.21,14.26C17.27,14.37 17.25,14.87 17,15.44C16.8,16 15.76,16.54 15.3,16.56C14.84,16.58 14.83,16.92 12.34,15.83C9.85,14.74 8.35,12.08 8.23,11.91C8.11,11.74 7.27,10.53 7.31,9.3C7.36,8.08 8,7.5 8.26,7.26C8.5,7 8.77,6.97 8.94,7H9.41C9.56,7 9.77,6.94 9.96,7.45L10.65,9.32C10.71,9.45 10.75,9.6 10.66,9.76L10.39,10.17L10,10.59C9.88,10.71 9.74,10.84 9.88,11.09C10,11.35 10.5,12.18 11.2,12.87C12.11,13.75 12.91,14.04 13.15,14.17C13.39,14.31 13.54,14.29 13.69,14.13L14.5,13.19C14.69,12.94 14.85,13 15.08,13.08L16.75,13.96M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22C10.03,22 8.2,21.43 6.65,20.45L2,22L3.55,17.35C2.57,15.8 2,13.97 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12C4,13.72 4.54,15.31 5.46,16.61L4.5,19.5L7.39,18.54C8.69,19.46 10.28,20 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z" /></svg></span>
							Whatsapp
						</a>

						<a class="link-share-clipboard" @click="clipboard($event)">
							<i class="icon"><svg viewBox="0 0 24 24"><path fill="#000000" d="M19,21H8V7H19M19,5H8A2,2 0 0,0 6,7V21A2,2 0 0,0 8,23H19A2,2 0 0,0 21,21V7A2,2 0 0,0 19,5M16,1H4A2,2 0 0,0 2,3V17H4V3H16V1Z" /></svg></i>
							&nbsp;<span>Copiar link</span>
						</a>

					</div>

					<!--
					&picture=http%3A%2F%2Fwww.applezein.net%2Fwordpress%2Fwp-content%2Fuploads%2F2015%2F03%2Ffacebook-logo.jpg
					&title=A+nice+question+about+Facebook
					&quote=Does+anyone+know+if+there+have+been+recent+changes+which+could+have+suddenly+stopped+this+from+working%3F
					&description=Apparently%2C+the+accepted+answer+is+not+correct.
				-->

				</section>
			</div>
		</div>



		<div v-if="modalWarning" class="modal modal-warning is-active">
			<div class="modal-background"></div>
			<div class="modal-card">
				<header class="modal-card-head">
					<p class="modal-card-title">Compartilhar Categoria - <span class="has-text-danger">Atenção</span></p>
					<button class="delete" aria-label="close" @click="closeModalWarning"></button>
				</header>
				<section class="modal-card-body">
					<p>Para compartilhar uma categoria, é preciso ser um usuário registrado. Clique no botão abaixo para efetuar o registro rápido.<br> É grátis! </p>
				</section>
				<div class="modal-card-foot">
					<button class="button is-success" @click.prevent="identifyAnonymous">Registrar</button>
				</div>
			</div>
		</div>



	</div>
</template>

<style>

.category-color-options  {  }
.category-color-options h4 { }
.category-color-options .field { }
.category-color-options label {display:inline-block; margin:0 5px 5px 0;}
.category-color-options input { display:none; }
.category-color-options span { display:block; width:40px; height:40px; border:1px solid #444; }
.category-color-options input:checked + span { border:2px solid #ffff00; }

.modal-form-category .modal-card-foot  { display: block; }

.button-delete .icon svg{width:20px; height:20px; display:block;}
.button-delete .icon svg path { fill:#c00; }

.button-share{}
.button-share .icon{  }
.button-share .icon svg{width:20px; height:20px; display:block;}
.button-share .icon svg path { fill:#0057ff; }



.modal-share {  }
.modal-share .modal-card-body a + a { margin-left:10px; }
.modal-share .modal-card-body a:hover { color:#fff; text-decoration:underline;}
.modal-card-body p { color:#4a4a4a; margin-bottom:10px;}
.share-link { word-break: break-all; }

.link-share-facebook { display:inline-block; background-color:#3b5998; color: #fff; padding: 7px 10px; border-radius: 5px; line-height: 24px;}
.link-share-facebook .icon { width: 24px; height: 24px; vertical-align: -7px;}
.link-share-facebook .icon svg {width:100%; height:100%; display:block;}
.link-share-facebook .icon svg path { fill:#fff; }

.link-share-whatsapp { display:inline-block; background-color:#25d366; color: #fff; padding: 7px 10px; border-radius: 5px; line-height: 24px;}
.link-share-whatsapp .icon { width: 24px; height: 24px; vertical-align: -7px;}
.link-share-whatsapp .icon svg {width:100%; height:100%; display:block;}
.link-share-whatsapp .icon svg path { fill:#fff; }

.link-share-clipboard { display:inline-block; background-color:rgb(255, 153, 51); color: #fff; padding: 7px 10px; border-radius: 5px; line-height: 24px;}
.link-share-clipboard .icon { width: 24px; height: 24px; vertical-align: -7px;}
.link-share-clipboard .icon svg {width:100%; height:100%; display:block;}
.link-share-clipboard .icon svg path { fill:#fff; }

body.is-mobile .link-share-buttons { display: flex; }

body.is-mobile .modal-share .modal-card-body a { font-size: 14px; padding: 7px 9px; white-space: nowrap; letter-spacing: -0.5px; }
body.is-mobile .modal-share .modal-card-body a + a  { margin-left:5px; }

</style>
<script>

import firebase from '@/firebase'
import Spinner from '../components/Spinner'
//import clipboard from 'clipboard'

export default {
	components:{
		Spinner
	},
	props:['item'],
	data() {
		return {
			name: '',
			theme:'',

			modalShare:false,
			modalWarning:false,
			share_id:'',
			isLoading:false,
		}
	},
	computed: {
		userId() {
			return this.$store.getters.userId;
		},
		userName() {
			return this.$store.getters.user.firstName
		},
		share_link(){
			return encodeURI('https://meu.urlinks.com.br/shared/'+this.share_id);
		}
	},
	methods:{

		clipboard(evt){
			var elm = document.querySelector('.modal-share .modal-card-body input');
			var button = document.querySelector('.link-share-clipboard span');
			elm.setAttribute('type', 'text');
			elm.select();
			try {
				var successful = document.execCommand('copy');
				var msg = successful ? 'successful' : 'unsuccessful';
				var originalTxtButton = button.innerText;
				button.innerText = 'Copiado!';
				setTimeout(()=>{ button.innerText = originalTxtButton; },2000);
			} catch (err) {
				alert('Oops, unable to copy');
			}
			elm.setAttribute('type', 'hidden');
			window.getSelection().removeAllRanges();
		},
		identifyAnonymous(){
			this.$store.dispatch('anonymousRedirectLogin');
		},
		onShare(){
			if(this.$store.getters.user.isAnonymous){
				this.modalWarning = true;
				return;
			}
			this.isLoading = true;
    	this.modalShare = true;
			let uid = uniqid();
			let category = {
				uid:uid,
				name:this.name,
				user_id:this.$store.getters.userId,
				category_id:this.item.id,
				created_at: new Date().getTime(),
				links:this.categoryLinks(this.item.id),
			}
			if(this.userName) category.userName = this.userName;
			const db = firebase.firestore();
      db.collection('shared_categories').doc(uid).set(category).then(()=>{
      	this.share_id = uid;
      	this.isLoading = false;

      }).catch(()=>{
      	this.isLoading = false;
      })

		},

		categoryLinks(category_id){
			return this.$store.getters.categoryLinks(category_id);
		},
		closeModalWarning(){
			this.modalWarning = false;
		},
		closeModalShare(){
			this.modalShare = false;
		},

		goBack(){
			this.$router.push({name:'home'})
		},
		onSubmit(){

			var data = {
				name:this.name,
			};
			if(this.theme) data.theme = this.theme;

			if(this.item){
				this.$store.dispatch('updateCategory',{category_id:this.item.id,data:data});
			} else {

				data.id = data.name.replace(/[\s/]+/g,'-').toLowerCase();
				data.column = 1;
				data.index = 1;
				this.$store.dispatch('addCategory',{data:data});
			}

			if(askRegisterAnonymous(this.$store.state)) {
				this.$router.push({name:'formRegistrar'});
				return;
			}


			this.goBack();
		},
		onDelete(){
			if(!confirm('Tem certeza?')) return;
			this.$store.dispatch('deleteCategory',{category_id:this.item.id});
			this.goBack();
		},


	},
	mounted() {
		if(this.item){
			console.log('item',this.item);
			this.name = this.item.name;
			this.theme = this.item.theme;
		}

	},
	beforeDestroy() {
	},
};
</script>


<style>
</style>
